
import React, { useEffect } from 'react';
import { useState } from 'react';
import "./getphoto.css"
import { Link, json, useParams } from 'react-router-dom';
import {Container , Button, Col} from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { use } from 'i18next';


const  Edithototeamwork = () =>{
    const [name, setName] = useState('');
    let navigt = useNavigate();
    let { id } = useParams(); // id of photo to update it 
    const handleImage =(e)=>{
        setName(e.target.files[0]) 
    }
    const  formSubmit = (e)=>{
        e.preventDefault()
        const formData = new FormData()
        formData.append('name', name)
 
        axios.post(`https://backend.dasta.net/api/auth/updatephotonewteam/${id}`,formData).then((res)=>{
            console.log(res)
        }).then((data)=>{
            navigt(-1);
        })
    }  

    return(
        <>
        <form onSubmit={formSubmit}>
            <input type="file" name="file" onChange={(e)=>setName(e.target.files[0])}/>
            <button type='submit' >submit</button>
        </form>
        </>
    )

}
export default Edithototeamwork;